export default __webpack_public_path__ + "static/media/TurnUpTheFun.0d2978cb.png";